import React, { FC } from 'react';

import useFormatter from 'src/hooks/useFormatter';

interface MoneyValueCustomCurrencyProps {
  className?: string;
  value: number;
}

const MoneyValueCustomCurrency: FC<MoneyValueCustomCurrencyProps> = ({ className, value }) => {
  const { currencyFormatter } = useFormatter();

  const html = currencyFormatter
    .format(value, { minimumFractionDigits: 2 })
    .replace(/([^\d.,\s]+)/g, '<span class="currency-symbol" />$1</span>');

  return <span className={className} dangerouslySetInnerHTML={{ __html: html }} />;
};

export default MoneyValueCustomCurrency;
